<div class="dual-select">
  <div class="dual-select__column dual-select__left">
    <ul class="dual-select__items">
      <li
        *ngFor="let item of selectableItems"
        (click)="togglePendingSelection(item)"
        (dblclick)="addToSelectedItems(item)"
        class="dual-select__item"
        [class.dual-select__item--selected]="pendingSelection[item.id]"
      >
        <div class="item-content">
          <div class="item-name">{{ item.name }}</div>
          <div *ngIf="item.description" class="item-description">{{ item.description }}</div>
        </div>
      </li>
    </ul>
  </div>

  <div class="dual-select__controls">
    <button (click)="addToSelectedItems()" class="dual-select__control">&#10503;</button>
    <button (click)="removeFromSelectedItems()" class="dual-select__control">&#10502;</button>
  </div>

  <div class="dual-select__column dual-select__right">
    <ul class="dual-select__items">
      <li
        *ngFor="let item of internalSelectedItems"
        (click)="togglePendingSelection(item)"
        (dblclick)="removeFromSelectedItems(item)"
        class="dual-select__item dual-select__item--new"
        [class.dual-select__item--selected]="pendingSelection[item.id]"
      >
        <div class="item-content">
          <div class="item-name">{{ item.name }}</div>
          <div *ngIf="item.description" class="item-description">{{ item.description }}</div>
        </div>
      </li>
    </ul>
  </div>
</div>

<p class="note">
  You have <strong>{{ internalSelectedItems.length }} of {{ items.length }}</strong> items selected.
</p>
